import { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, hasActiveAccess } from "@/contexts/AuthContext";

/**
 * Blocks access to subscriber-only routes (projects, search, compare) when the
 * user's trial has ended or their subscription is canceled. Redirects to the
 * billing page so they can subscribe. Admins + active/trialing users pass.
 */
export default function SubscriptionGate({ children }) {
  const { user } = useAuth();
  const notified = useRef(false);
  const access = hasActiveAccess(user);

  useEffect(() => {
    if (user && typeof user === "object" && !access && !notified.current) {
      notified.current = true;
      toast.error(
        "Your subscription has ended. Subscribe to keep using Atelier Studio."
      );
    }
  }, [user, access]);

  // Still resolving the session — let ProtectedRoute handle the loading state.
  if (user === null) return null;
  if (!access) return <Navigate to="/profile" replace />;
  return children;
}
